import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fgCustomManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  fgCustomManageForecastTreeData: [],
  fgCustomManageForecastFinalTreeData: [],
};

const FGCustomManageScreenRedux = createSlice({
  name: "FGCustomManageScreenRedux",
  initialState,
  reducers: {
    setFGCustomManageForecastBottlerData: (state, action) => {
      state.fgCustomManageForecastBottlerData = action.payload;
    },
    setFGCustomManageForecastTreeData: (state, action) => {
      state.fgCustomManageForecastTreeData = action.payload;
    },
    setFGCustomManageForecastFinalTreeData: (state, action) => {
      state.fgCustomManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setFGCustomManageForecastBottlerData,
  setFGCustomManageForecastTreeData,
  setFGCustomManageForecastFinalTreeData,
} = FGCustomManageScreenRedux.actions;
export default FGCustomManageScreenRedux.reducer;
